module.exports = __webpack_public_path__ + "img/warehouse-management.97c8173e.png";